import { useContext, useCallback } from "react";
import { LayoutContext } from "./context";

/**
 * Проверяет наличие конкретного права у текущего пользователя.
 * Родительский аккаунт имеет все права ('__all__').
 * Дочерний аккаунт — только те, что в массиве permissions.
 */
export function usePermissions() {
  const { permissions, isChildAccount } = useContext(LayoutContext);

  const hasPermission = useCallback((permType) => {
    if (permissions === '__all__') return true;
    if (Array.isArray(permissions)) return permissions.includes(permType);
    return false;
  }, [permissions]);

  const hasAnyPermission = useCallback((...permTypes) => {
    if (permissions === '__all__') return true;
    if (Array.isArray(permissions)) return permTypes.some(p => permissions.includes(p));
    return false;
  }, [permissions]);

  return { hasPermission, hasAnyPermission, isChildAccount, permissions };
}